import { Anchor, Card, Container, List, Stack, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

// The console's privacy notice. It holds one section so far, the
// Reichweitenmessung, because that is the one processing the console added
// on its own; socrates-tutor.com/datenschutz covers the website and says
// outright that it does not cover the app. A legal text: a change here is
// the founder's to approve before it merges.
//
// What it says has to stay true of lib/analytics.ts — which pages count,
// what is cut from them, and that a child is never counted.

/** What the console measures about the parents who use it. */
export function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <Container size="sm" py="xl">
      <Stack>
        <Title order={2}>Datenschutz in der Sokrates-App</Title>
        <Text size="sm" c="dimmed">
          Diese Hinweise gelten für die Sokrates-App unter app.socrates-tutor.com. Verantwortlich
          ist der Anbieter, den das{' '}
          <Anchor href="https://socrates-tutor.com/impressum/" target="_blank" rel="noopener">
            Impressum
          </Anchor>{' '}
          nennt.
        </Text>

        <Card withBorder padding="lg">
          <Stack gap="sm">
            <Text fw={600}>Reichweitenmessung mit Umami</Text>
            <Text size="sm">
              Um zu verstehen, wie oft Eltern die App nutzen, setzen wir Umami ein, eine
              datensparsame Open-Source-Software. Wir betreiben Umami selbst auf einem Server bei
              der netcup GmbH in Deutschland; die Daten gehen an keine Dritten.
            </Text>
            <Text size="sm">Gemessen wird nur auf den Seiten für Eltern:</Text>
            <List size="sm" spacing={4}>
              <List.Item>Anmelden, Konto und Familie anlegen, Adresse bestätigen, Passwort setzen</List.Item>
              <List.Item>der Eltern-Bereich (Überblick, Kinder, Lehrplan, Arbeitsblätter, Abo, Sicherheit)</List.Item>
            </List>
            <Text size="sm">
              Nicht gemessen wird bei Kindern: nicht in der Profilauswahl, nicht in einer
              Lernsitzung oder einem Rätsel, nicht solange ein Kind angemeldet ist und nie in der
              Sokrates-App für Tablet und Smartphone.
            </Text>
            <Text size="sm">
              Erfasst werden die aufgerufene Seite, die Website, von der Sie kamen (nur ihre
              Adresse, ohne Pfad), Browser, Betriebssystem, Gerätetyp, Bildschirmgröße, Sprache
              und das Land. Die Seitenadresse wird vor dem Senden gekürzt: ohne Kennungen, ohne
              Namen und ohne Parameter, so dass sich keine Familie und kein Kind darin findet.
            </Text>
            <Text size="sm">
              Umami setzt keine Cookies und speichert keine IP-Adressen: Aus IP-Adresse und
              Browserangaben wird ein Kennwert gebildet, der sich regelmäßig ändert und keinen
              Rückschluss auf Ihre Person zulässt.
            </Text>
            <Text size="sm">
              Rechtsgrundlage ist unser berechtigtes Interesse an einer anonymen Auswertung der
              Nutzung (Art. 6 Abs. 1 lit. f DSGVO). Sie können widersprechen, indem Sie in Ihrem
              Browser „Do Not Track“ aktivieren; Umami erfasst dann nichts. Mit unserem
              Hosting-Anbieter netcup besteht ein Vertrag zur Auftragsverarbeitung.
            </Text>
          </Stack>
        </Card>

        <Anchor
          component="button"
          type="button"
          onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}
        >
          Zurück
        </Anchor>
      </Stack>
    </Container>
  );
}
